export enum ParticipantSectionDataHooks {
  ROOT = 'participant-section',
  HEADER = 'participant-section-header',
  BADGE = 'participant-section-badge',
  TITLE = 'participant-section-title',
  TOGGLE = 'participant-section-toggle',
  REMOVE = 'participant-section-remove',
  BODY = 'participant-section-body',
}
